import styled from 'styled-components';

import {
  scale010,
  scale050,
  xdlColorBackground,
  xdlColorMarkerHighlightText,
} from '@xing-com/tokens';

// *** Components ***
export const DiscoverBadge = styled.span`
  background: ${xdlColorMarkerHighlightText};
  border-color: ${xdlColorBackground};
  border-radius: 50%;
  border-style: solid;
  border-width: ${scale010};
  display: inline-flex;
  height: ${scale050};
  width: ${scale050};
  position: relative;
`;
